<template>
<div>
    <h1 class="mb-4 text-gray-500">Bilibili Downloader</h1>
    
    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/> 
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            How to use Bilibili Downloader
        </h2>
        <div class="mb-4"> 
            1. Go to Bilibili and copy the URL of the video you want to download.<br>
            2. Paste the URL into the input field above.<br>
            3. Click "Find media" to extract the video.<br>
            4. Once the video is found, click the download icon to start the download.
        </div>
    </el-card>
</div>
</template>
<script>
export default {
    created() {
        useHead({
            title: 'Bilibili Downloader',
            head: {
                meta: [
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'Download videos from Bilibili for offline viewing using our Chrome extension.',
                    }
                ]
            }
        })
    },
	data () {
        return {
        }
    }
}
</script>
